import React from "react";
import Lottie from 'react-lottie';
import animationData from '../../assets/loader/Loader.json';

const Spinner = ({size = 400}) => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <Lottie
            options={defaultOptions}
            height={size}
            width={size}
        />
    );
};

export default Spinner;

// import React from 'react';
// const Spinner = (props) => {
//     if(props.spinnerExtras)
//     return <div className="lds-ring"><div></div><div></div><div></div><div></div></div> ;

//     return <div className={"LoaderWrapper " + (props.size? props.size: "")}><div className="Loader">Loading...</div></div>
// };

// export default Spinner;